import { useMemo } from "react";
import { useRouteLoaderData } from "@remix-run/react";

import { useLabels } from "~/hooks/useLabels";
import { Text } from "~/components/text/Text";
import { Box } from "~/components/box/Box";
import { SidePanelLayout } from "~/components/sidePanelLayout/SidePanelLayout";

import { SessionNotes } from "./SessionNotes";

import type { SessionRouteLoaderData } from "./route";

export interface SessionNotebookProps {
  onRequestSeek?: (timestamp: number) => void;
  onRequestClose?: () => void;
  isDesktopLayout?: boolean;
}

export function SessionNotebook({
  onRequestSeek,
  onRequestClose,
  isDesktopLayout,
}: SessionNotebookProps) {
  const { t } = useLabels();
  const data = useRouteLoaderData(
    "routes/$class_.sessions.$session",
  ) as SessionRouteLoaderData;

  const content = useMemo(() => {
    if (!data.notes?.length) {
      return (
        <bp-empty-state>
          {t("notebook.personalNotes.empty.title")}
          <Text weight="normal">
            {t("notebook.personalNotes.empty.postTitle")}
          </Text>
        </bp-empty-state>
      );
    }

    return (
      <Box
        direction="column"
        gap="var(--size-2)"
        style={{ paddingBlockEnd: "var(--size-2)" }}
      >
        <SessionNotes onRequestSeek={onRequestSeek} />
      </Box>
    );
  }, [data.notes?.length, onRequestSeek, t]);

  if (isDesktopLayout) {
    return (
      <SidePanelLayout
        title={t("session.tab.notebook")}
        onRequestClose={onRequestClose}
      >
        {content}
      </SidePanelLayout>
    );
  }

  return content;
}
